import React, { useEffect, useState, useRef } from 'react';
import { getCollabActivity } from '../../services/api';

const EVENT_ICONS = {
  joined: '🟢', left: '🔴', invited: '📨', member_joined: '👋',
  member_removed: '🚫', role_changed: '🔄', file_created: '📄',
  file_deleted: '🗑️', file_renamed: '✏️', ai_applied: '🤖',
  deployed: '🚀', default: '📌',
};

function ActivityItem({ item }) {
  const icon = EVENT_ICONS[item.event_type] || EVENT_ICONS.default;
  const time = new Date(item.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return (
    <div style={{ display: 'flex', gap: 10, padding: '7px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }}>{icon}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 12, color: 'var(--text-primary)' }}>
          {item.user_email && <strong style={{ color: '#818cf8' }}>{item.user_email} </strong>}
          {item.detail || item.event_type}
        </span>
        <span style={{ fontSize: 10, color: 'var(--text-muted)', marginLeft: 8 }}>{time}</span>
      </div>
    </div>
  );
}

export default function ActivityFeed({ projectId, onClose, liveEvents = [] }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    getCollabActivity(projectId, 50)
      .then(setItems)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projectId]);

  // Append live events from WebSocket
  useEffect(() => {
    if (liveEvents.length === 0) return;
    setItems(prev => [...prev, ...liveEvents]);
  }, [liveEvents]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [items]);

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.panel} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <span style={{ fontWeight: 700, fontSize: 14 }}>📋 Activity Feed</span>
          <button onClick={onClose} style={s.closeBtn}>✕</button>
        </div>
        <div style={s.body}>
          {loading && <p style={s.muted}>Loading...</p>}
          {!loading && items.length === 0 && <p style={s.muted}>No activity yet.</p>}
          {items.map(item => <ActivityItem key={item.id} item={item} />)}
          <div ref={bottomRef} />
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' },
  panel: { background: 'var(--bg-card)', borderLeft: '1px solid var(--border)', width: 340, height: '100vh', display: 'flex', flexDirection: 'column', boxShadow: '-8px 0 32px rgba(0,0,0,0.3)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid var(--border)' },
  closeBtn: { background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 16, cursor: 'pointer' },
  body: { flex: 1, overflowY: 'auto', padding: '8px 20px' },
  muted: { fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', padding: '20px 0' },
};
